/** Dates on the website are always DD/MM/YYYY (times as 9:05 AM). */
const two = (n: number) => String(n).padStart(2, '0');
const WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const WD_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const toDate = (d: Date | string) => (typeof d === 'string' ? new Date(d) : d);

/** A moment (Date or ISO time) on this computer's clock: "05/03/2026". */
export function fmtDMY(d: Date | string): string {
  const x = toDate(d);
  return `${two(x.getDate())}/${two(x.getMonth() + 1)}/${x.getFullYear()}`;
}
/** A calendar day "YYYY-MM-DD": "05/03/2026"; withWeekday: "Thursday, 05/03/2026" (long) or "Thu 05/03/2026". */
export function fmtDayDMY(iso: string, withWeekday?: 'long' | 'short'): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
  if (!m) return iso || '';
  const s = `${m[3]}/${m[2]}/${m[1]}`;
  if (!withWeekday) return s;
  const wd = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])).getUTCDay();
  return withWeekday === 'long' ? `${WD_LONG[wd]}, ${s}` : `${WD[wd]} ${s}`;
}
/** "9:05 AM" */
export function fmtClock12(d: Date | string): string {
  const x = toDate(d);
  return `${x.getHours() % 12 || 12}:${two(x.getMinutes())} ${x.getHours() >= 12 ? 'PM' : 'AM'}`;
}
/** "05/03/2026, 9:05 AM"; withWeekday: "Thu 05/03/2026, 9:05 AM" */
export function fmtDMYTime(d: Date | string, withWeekday = false): string {
  const x = toDate(d);
  return `${withWeekday ? WD[x.getDay()] + ' ' : ''}${fmtDMY(x)}, ${fmtClock12(x)}`;
}
